import React from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useCollectionQuery } from '@annunciate/query';
import { View, MemoizedCollection as BaseCollection, } from '@annunciate/ui/dist/components';
export const Collection = ({ collectionId, }) => {
    const { isPending, error, data } = useCollectionQuery(collectionId);
    const collection = data?.Collection;
    if (error)
        console.error(error);
    return (React.createElement(View, { style: { flexGrow: 1 } },
        React.createElement(React.Fragment, null,
            isPending && (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
                React.createElement(Text, null, "Loading..."),
                React.createElement(LinearProgress, { style: { marginVertical: 10 } }))),
            error && React.createElement(Text, null, "Error :("),
            collection && (React.createElement(BaseCollection, { collection: collection })))));
};
//# sourceMappingURL=Collection.js.map